module.exports = __webpack_public_path__ + "img/icon_dean_home_bg_card_icon_13.f5721e30.png";